import {
  PRICE_ALERTS_FETCH,
  PRICE_ALERTS_SUCCESS,
  PRICE_ALERTS_ERROR,
  PRICE_ALERT_FETCH,
  PRICE_ALERT_SUCCESS,
  PRICE_ALERT_ERROR,
  PATCH_PRICE_ALERTS,
  PATCH_PRICE_ALERTS_SUCCESS,
  PATCH_PRICE_ALERTS_ERROR,
  PATCH_PRICE_ALERT,
  PATCH_PRICE_ALERT_SUCCESS,
  PATCH_PRICE_ALERT_ERROR,
  DELETE_PRICE_ALERT,
  DELETE_PRICE_ALERT_SUCCESS,
  DELETE_PRICE_ALERT_ERROR,
  POST_PRICE_ALERT,
  POST_PRICE_ALERT_SUCCESS,
  POST_PRICE_ALERT_ERROR,
  DISMISS_PRICE_ALERT_BADGE,
  DISMISS_PRICE_ALERT_BANNER,
  SETUP_MOCK_PRICE_ALERTS,
  CLEAR_EXPIRED_PRICE_ALERTS,
  CLEAR_EXPIRED_PRICE_ALERTS_SUCCESS,
  CLEAR_EXPIRED_PRICE_ALERTS_ERROR,
} from './priceAlertsActionConstants';

export const fetchPriceAlerts = (payload) => ({
  type: PRICE_ALERTS_FETCH,
  payload,
});

export const fetchPriceAlert = (payload) => ({
  type: PRICE_ALERT_FETCH,
  payload,
});

export const fetchPriceAlertSuccess = (payload) => ({
  type: PRICE_ALERT_SUCCESS,
  payload,
});

export const fetchPriceAlertError = (payload) => ({
  type: PRICE_ALERT_ERROR,
  payload,
});

export const fetchPriceAlertsSuccess = (payload, productCode) => ({
  type: PRICE_ALERTS_SUCCESS,
  payload,
  productCode,
});

export const fetchPriceAlertsError = (payload) => ({
  type: PRICE_ALERTS_ERROR,
  payload,
});

export const patchPriceAlerts = (payload) => ({
  type: PATCH_PRICE_ALERTS,
  payload,
});

export const patchPriceAlertsSuccess = (payload) => ({
  type: PATCH_PRICE_ALERTS_SUCCESS,
  payload,
});

export const patchPriceAlertsError = (payload) => ({
  type: PATCH_PRICE_ALERTS_ERROR,
  payload,
});

export const patchPriceAlert = (payload) => ({
  type: PATCH_PRICE_ALERT,
  payload,
});

export const patchPriceAlertSuccess = (payload) => ({
  type: PATCH_PRICE_ALERT_SUCCESS,
  payload,
});

export const patchPriceAlertError = (payload) => ({
  type: PATCH_PRICE_ALERT_ERROR,
  payload,
});

export const deletePriceAlert = (payload) => ({
  type: DELETE_PRICE_ALERT,
  payload,
});

export const deletePriceAlertSuccess = (payload) => ({
  type: DELETE_PRICE_ALERT_SUCCESS,
  payload,
});

export const deletePriceAlertError = (payload) => ({
  type: DELETE_PRICE_ALERT_ERROR,
  payload,
});

export const postPriceAlert = (payload) => ({
  type: POST_PRICE_ALERT,
  payload,
});

export const postPriceAlertSuccess = (payload) => ({
  type: POST_PRICE_ALERT_SUCCESS,
  payload,
});

export const postPriceAlertError = (payload) => ({
  type: POST_PRICE_ALERT_ERROR,
  payload,
});

export const dismissPriceAlertBadge = (payload) => ({
  type: DISMISS_PRICE_ALERT_BADGE,
  payload,
});

export const dismissPriceAlertBanner = (payload) => ({
  type: DISMISS_PRICE_ALERT_BANNER,
  payload,
});

export const setupMockPriceAlerts = (payload) => ({
  type: SETUP_MOCK_PRICE_ALERTS,
  payload,
});

export const clearExpiredPriceAlerts = (payload) => ({
  type: CLEAR_EXPIRED_PRICE_ALERTS,
  payload,
});

export const clearExpiredPriceAlertsSuccess = (payload) => ({
  type: CLEAR_EXPIRED_PRICE_ALERTS_SUCCESS,
  payload,
});

export const clearExpiredPriceAlertsError = (payload) => ({
  type: CLEAR_EXPIRED_PRICE_ALERTS_ERROR,
  payload,
});
